import { styled, Button, Box, Grid } from "@mui/material";
import {
  DESKTOP_4K_SIZE_SCREEN,
  LAPTOP_SIZE_SCREEN,
  MOBILE_SIZE_SCREEN,
  SMALL_MOBILE_SIZE_SCREEN,
} from "../constants";
import { TopBarSearchStyledBoxProps } from "../types/interface";

export const StylexButton = styled(Button)`
  font-size: 12px;
  font-weight: 500;
`;

export const StyledBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  margin: auto;
  border: 12px solid #f5f8f9;
  padding: 2rem;
  align-content: center;
`;

export const TopBarStyeldBox = styled(Box)<TopBarSearchStyledBoxProps>`
  ${({ deviceSize }) =>
    deviceSize &&
    `
    display: ${
      deviceSize === DESKTOP_4K_SIZE_SCREEN || deviceSize === LAPTOP_SIZE_SCREEN
        ? "flex"
        : "none"
    };
  `}
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const TopBarSearchStyledBox = styled(Box)<TopBarSearchStyledBoxProps>`
  align-items: center;
  margin-right: 1rem;
  margin-left: ${({ deviceSize }) =>
    deviceSize === SMALL_MOBILE_SIZE_SCREEN || deviceSize === MOBILE_SIZE_SCREEN
      ? "0"
      : "1rem"};
  justify-content: center;
  background-color: #ffffff;
  border: 1px solid #00000166;
  border-radius: 8px;
  flex: ${({ deviceSize }) =>
    deviceSize === DESKTOP_4K_SIZE_SCREEN || deviceSize === LAPTOP_SIZE_SCREEN
      ? "0 0 56%"
      : "0 0 84%"};
`;

export const StyledBoxForImageGallery = styled(Box)`
  position: sticky;
  top: 0px;
  z-index: 99;
  width: 100%;
  background: #f5f6f9;
  padding: 10px 0;
  margin-top: 0;
`;

export const StyledGridItemForImageGallery = styled(Grid)`
  padding: 0;
  background: #ffffff;
  border: 3px solid #f5f6f9;
  border-radius: 14px;
  outline: 4px solid #ffffff;
`;

export const StyledUpoadBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-radius: 8px;
  //   background: linear-gradient(to right, #b1bfd0 33%, #fff 0%) top/10px 1px
  //       repeat-x,
  //     linear-gradient(#b1bfd0 33%, #fff 0%) right/1px 10px repeat-y,
  //     linear-gradient(to right, #b1bfd0 33%, #fff 0%) bottom/10px 1px repeat-x,
  //     linear-gradient(#b1bfd0 33%, #fff 0%) left/1px 10px repeat-y;
  border: 2px dashed #b1bfd0;
`;
